import { Heading } from '@cinch-labs/design-system'
import {
  CtaButton,
  CtaButtonProps,
  StoreType,
} from '@cinch-nx/landing-ui-shared'
import { StoryBlokHowCinchWorksListItem } from '../../types/store-page'
import { StoreCtaButton } from '../cta-button'
import { IconCard } from '../icon-card'
import styles from './how-it-works.module.css'

export interface HowItWorksProps {
  title: string
  howCinchWorksList: StoryBlokHowCinchWorksListItem[]
  slug: string
  storeName: string
  storeType: StoreType
  cta?: CtaButtonProps
}

export function HowItWorks({
  title,
  howCinchWorksList,
  slug,
  storeName,
  cta,
  storeType,
}: HowItWorksProps) {
  return (
    <section className={styles.root}>
      <Heading className={styles.title}>{title}</Heading>
      <div className={styles.cardList}>
        {howCinchWorksList.map((listItem) => (
          <IconCard
            icon={listItem.icon}
            title={listItem.title}
            body={listItem.body}
            key={listItem.title}
          />
        ))}
      </div>
      {storeType !== StoreType.clickAndCollect &&
        (cta ? (
          <CtaButton {...cta} />
        ) : (
          <StoreCtaButton
            slug={slug}
            storeName={storeName}
            trackEventTitle="how it works"
          />
        ))}
    </section>
  )
}
